/** Generated from docs/research/dir-ir-guidance.json (read from official sources, verified 2026-11-03). Details marked `needsCheck` could not be fully verified; the UI tells people to confirm on the official page. We deliberately publish NO list of IR firms (InventiveHQ sells these services). */
export interface IrItem {
  id: string; title: string; organization: string; summary: string; urls: { label: string; url: string }[]
  kind: "guidance" | "list" | "insurer-panel" | "credential" | "checklist"; needsCheck: boolean; verifiedOn: string
}
export interface IrQuestion { id: string; topic: string; question: string; sourceLabel: string | null; sourceUrl: string | null }
export const IR_ITEMS: IrItem[] = [
  {
    "id": "nist-800-61r3-third-parties",
    "title": "NIST SP 800-61r3: third parties and contracted incident handlers",
    "organization": "NIST (US Dept. of Commerce)",
    "summary": "NIST's April 2025 incident response profile says an organization's incident handlers may be on staff, on contract (e.g. an MSSP or a cloud provider's response team), or available when needed (e.g. from a cybersecurity services provider). Section 2.2 says third parties under contract share responsibility, so the contract should define responsibilities, information flows, coordination and authority to act, plus limits on what the provider may do (e.g. sharing sanitized incident data with other customers, or taking operational decisions such as deactivating services). It also notes providers often have privileged access to systems and sensitive data, so insider and provider-compromise risk should be addressed, with NDAs and contract clauses named as options.",
    "urls": [
      {
        "label": "NIST SP 800-61r3 (PDF), Section 2.2 Incident Response Roles and Responsibilities",
        "url": "https://nvlpubs.nist.gov/nistpubs/SpecialPublications/NIST.SP.800-61r3.pdf"
      },
      {
        "label": "NIST CSRC publication page (final, April 2025)",
        "url": "https://csrc.nist.gov/pubs/sp/800/61/r3/final"
      }
    ],
    "kind": "guidance",
    "needsCheck": true,
    "verifiedOn": "2026-11-03"
  },
  {
    "id": "ftc-data-breach-response-forensics",
    "title": "FTC: Data Breach Response, A Guide for Business (forensics team)",
    "organization": "Federal Trade Commission",
    "summary": "Under 'Secure Your Operations' the FTC guide tells businesses to assemble a team of experts and to identify a data forensics team, considering independent forensic investigators to find the source and scope of the breach, and to consult legal counsel (possibly outside counsel with privacy expertise). Under 'Fix Vulnerabilities' it says to work with the forensics experts and act promptly on their reports. The page printed date is August 2023. It does not mention cyber insurance.",
    "urls": [
      {
        "label": "FTC Data Breach Response: A Guide for Business",
        "url": "https://www.ftc.gov/business-guidance/resources/data-breach-response-guide-business"
      }
    ],
    "kind": "guidance",
    "needsCheck": true,
    "verifiedOn": "2026-11-03"
  },
  {
    "id": "cisa-incident-response-plan-basics",
    "title": "CISA Incident Response Plan (IRP) Basics",
    "organization": "CISA",
    "summary": "CISA's IRP Basics fact sheet advises reviewing the plan with an attorney and notes that attorneys often have preferences on how to engage outside incident response vendors, law enforcement and other stakeholders. This supports engaging a firm through counsel when counsel wants that.",
    "urls": [
      {
        "label": "CISA IRP Basics (PDF)",
        "url": "https://www.cisa.gov/sites/default/files/publications/Incident-Response-Plan-Basics_508c.pdf"
      }
    ],
    "kind": "guidance",
    "needsCheck": true,
    "verifiedOn": "2026-11-03"
  },
  {
    "id": "cisa-ransomware-data-breach-factsheet",
    "title": "CISA: Protecting Sensitive and Personal Information from Ransomware-Caused Data Breaches",
    "organization": "CISA",
    "summary": "In the response checklist CISA says to engage internal and external teams and to strongly consider requesting help from a reputable third-party incident response provider with data-breach experience. It does not name or list providers.",
    "urls": [
      {
        "label": "CISA fact sheet (PDF), response checklist item 1e",
        "url": "https://www.cisa.gov/sites/default/files/publications/CISA_Fact_Sheet-Protecting_Sensitive_and_Personal_Information_from_Ransomware-Caused_Data_Breaches-508C.pdf"
      }
    ],
    "kind": "guidance",
    "needsCheck": true,
    "verifiedOn": "2026-11-03"
  },
  {
    "id": "cisa-stopransomware-guide",
    "title": "CISA #StopRansomware Guide: engaging outside parties",
    "organization": "CISA (with MS-ISAC)",
    "summary": "The guide says to engage internal and external teams, naming IT, managed security service providers and the cyber insurer as contacts to fill in ahead of time, notes that federal agencies can voluntarily help determine the extent of a compromise, and recommends contract language to formalize security requirements with MSPs.",
    "urls": [
      {
        "label": "CISA #StopRansomware Guide",
        "url": "https://www.cisa.gov/stopransomware/ransomware-guide"
      }
    ],
    "kind": "guidance",
    "needsCheck": true,
    "verifiedOn": "2026-11-03"
  },
  {
    "id": "sba-forensics",
    "title": "SBA page on engaging forensic experts",
    "organization": "U.S. Small Business Administration",
    "summary": "No SBA page saying to engage forensic experts was found. The guessed URLs sba.gov/blog/what-do-if-your-small-business-suffers-data-breach and sba.gov/business-guide/manage-your-business/cybersecurity returned HTTP 404. Do not cite SBA for this point.",
    "urls": [],
    "kind": "guidance",
    "needsCheck": true,
    "verifiedOn": "2026-11-03"
  },
  {
    "id": "cisa-cyber-incident-response-service",
    "title": "CISA Cyber Incident Response service",
    "organization": "CISA",
    "summary": "CISA's own incident response and coordination service is described for critical infrastructure sectors and federal, state, local, tribal and territorial government entities, with remote and on-site engagement types. The page does not state eligibility rules, cost, or a request process, and does not list or accredit commercial providers. CISA's small and medium business page points to a no-cost services repository and regional Cybersecurity Advisors, and to the 'Report a Cyber Issue' form.",
    "urls": [
      {
        "label": "CISA Cyber Incident Response",
        "url": "https://www.cisa.gov/resources-tools/services/cyber-incident-response"
      },
      {
        "label": "CISA Small and Medium Businesses",
        "url": "https://www.cisa.gov/audiences/small-and-medium-businesses"
      }
    ],
    "kind": "list",
    "needsCheck": true,
    "verifiedOn": "2026-11-03"
  },
  {
    "id": "pci-pfi-list",
    "title": "PCI SSC list of PCI Forensic Investigators (PFI)",
    "organization": "PCI Security Standards Council",
    "summary": "Public, free directory on the Council's site of forensic firms qualified under the PFI program for payment card breaches. Filters: place of business, language, region and servicing country (markets such as AP, CEMEA, LAC); click a company for details; an 'Export List' option exists. 'In Remediation' marks PFIs in the PFI Remediation Program that may still perform investigations. PFIs must work for a Qualified Security Assessor company with a dedicated forensic practice. The page says clients should confirm status each time they engage a PFI, that the list is updated frequently and may not be current, and that qualification is not an endorsement of the provider's business practices.",
    "urls": [
      {
        "label": "PCI SSC: PCI Forensic Investigators",
        "url": "https://www.pcisecuritystandards.org/assessors_and_solutions/pci_forensic_investigators"
      }
    ],
    "kind": "list",
    "needsCheck": true,
    "verifiedOn": "2026-11-03"
  },
  {
    "id": "pci-pfi-engagement",
    "title": "When and how a PFI is engaged (acquirer and card brands)",
    "organization": "PCI Security Standards Council",
    "summary": "The PFI Program Guide (v3.2r1, Nov 2021) says that after a security issue an entity may be required under industry rules to notify its acquiring bank and/or affected payment brands and to engage a PCI SSC-qualified PFI. The Council's 'Responding to a Cardholder Data Breach' guidance says acquirers and brands each have their own thresholds for when a PFI must be engaged, so contact them to decide; only PFIs listed on the Council site are approved for card breach investigations; some PFIs offer retainers; PFIs must be independent (your QSA firm cannot be your PFI); PFIs must be able to start within five business days of signing; the brands may also engage a PFI directly (Program Guide).",
    "urls": [
      {
        "label": "PCI SSC PFI Program Guide v3.2r1 (PDF), Section 1.1 Background",
        "url": "https://listings.pcisecuritystandards.org/documents/PFI_Program_Guide_v3.2r1.pdf"
      },
      {
        "label": "PCI SSC Responding to a Cardholder Data Breach (PDF), 'Engaging a PFI'",
        "url": "https://listings.pcisecuritystandards.org/documents/Responding_to_a_Cardholder_Data_Breach.pdf"
      }
    ],
    "kind": "guidance",
    "needsCheck": true,
    "verifiedOn": "2026-11-03"
  },
  {
    "id": "nsa-nscap",
    "title": "NSA National Security Cyber Assistance Program (NSCAP)",
    "organization": "National Security Agency",
    "summary": "NSA ran an accreditation program for commercial incident response providers; a search listing shows an NSCAP page and a 2019 PDF of accredited companies. The NSA pages returned HTTP 403 to the fetch tool so nothing was read from the official site. A 2014 CISA reference aid mentions an earlier NSA 'cyber assistance' accreditation framework. Do not present as a current list.",
    "urls": [
      {
        "label": "NSA NSCAP page (blocked, 403)",
        "url": "https://www.nsa.gov/What-We-Do/Cybersecurity/NSCAP"
      }
    ],
    "kind": "list",
    "needsCheck": true,
    "verifiedOn": "2026-11-03"
  },
  {
    "id": "crest-ir-accreditation",
    "title": "CREST incident response accreditation and Marketplace",
    "organization": "CREST (not-for-profit, UK-registered)",
    "summary": "CREST accredits companies for incident response after an expert-led assessment across six domains (per CREST's incident management page) and publishes accredited members on the CREST Marketplace, a searchable directory of about 551 companies with country, category and specialism filters. Some filters require a free account. CREST is an international body, not a US government program.",
    "urls": [
      {
        "label": "CREST incident management",
        "url": "https://www.crest-approved.org/cyber-service-categories/incident-management/"
      },
      {
        "label": "CREST accreditation",
        "url": "https://www.crest-approved.org/membership/accreditation/"
      },
      {
        "label": "CREST Marketplace supplier search",
        "url": "https://marketplace.crest.org/suppliers/"
      }
    ],
    "kind": "list",
    "needsCheck": true,
    "verifiedOn": "2026-11-03"
  },
  {
    "id": "ncsc-cir",
    "title": "NCSC Cyber Incident Response (CIR) scheme (UK)",
    "organization": "UK National Cyber Security Centre",
    "summary": "UK government scheme with a public 'find a provider' list of assured providers at Standard and Enhanced level. NCSC says all UK organisations should use an assured provider, and that it is not party to contracts. UK-only; relevant for readers with UK operations.",
    "urls": [
      {
        "label": "NCSC CIR introduction",
        "url": "https://www.ncsc.gov.uk/schemes/cyber-incident-response/introduction"
      },
      {
        "label": "NCSC information for buyers",
        "url": "https://www.ncsc.gov.uk/schemes/cyber-incident-response/information-for-buyers"
      },
      {
        "label": "NCSC find a provider",
        "url": "https://www.ncsc.gov.uk/schemes/cyber-incident-response/find-a-provider"
      }
    ],
    "kind": "list",
    "needsCheck": true,
    "verifiedOn": "2026-11-03"
  },
  {
    "id": "us-gov-provider-list",
    "title": "Any US government list of qualified commercial IR providers",
    "organization": "n/a",
    "summary": "No current official US government program publishing a public list of qualified commercial incident response providers was verified. CISA does not appear to list providers (see cisa-cyber-incident-response-service); NSA NSCAP could not be read. State this plainly rather than implying one exists.",
    "urls": [],
    "kind": "list",
    "needsCheck": true,
    "verifiedOn": "2026-11-03"
  },
  {
    "id": "insurer-chubb",
    "title": "Chubb: Cyber Incident Response Team partners",
    "organization": "Chubb",
    "summary": "Lists pre-approved forensics firms (separate US and Canada lists) on its partners page under 'Response, Forensics'. States the policyholder is under no obligation to contract with these providers, that the choice is the policyholder's independent choice, that Chubb does not endorse them, and that the policyholder should do its own due diligence.",
    "urls": [
      {
        "label": "Chubb Cyber partners for mitigation and response",
        "url": "https://www.chubb.com/us-en/business-insurance/products/cyber-insurance/cyber-partners-for-mitigation-and-response.html"
      },
      {
        "label": "Chubb cyber incident response solutions",
        "url": "https://www.chubb.com/us-en/business-insurance/products/cyber-insurance/cyber-incident-response-solutions.html"
      }
    ],
    "kind": "insurer-panel",
    "needsCheck": true,
    "verifiedOn": "2026-11-03"
  },
  {
    "id": "insurer-beazley",
    "title": "Beazley: report a cyber incident",
    "organization": "Beazley",
    "summary": "The claims page offers an online form and country contacts and describes Beazley Security, an in-house unit that helps insureds prepare for and respond to breaches. It does not mention an approved vendor panel, any must-use rule, or where a list lives.",
    "urls": [
      {
        "label": "Beazley report a cyber incident",
        "url": "https://www.beazley.com/en-150/cyber-customer-centre/report-a-cyber-incident/"
      }
    ],
    "kind": "insurer-panel",
    "needsCheck": true,
    "verifiedOn": "2026-11-03"
  },
  {
    "id": "insurer-travelers",
    "title": "Travelers: file a cyber claim",
    "organization": "Travelers",
    "summary": "The cyber claim page says to file immediately after a known or suspected breach. It does not mention approved vendors. Navigation has a 'Find a Service Provider' link to /claims/claim-services, but that page lists only workers' compensation medical, auto medical, auto repair and emergency property providers, not cyber.",
    "urls": [
      {
        "label": "Travelers cyber claims",
        "url": "https://www.travelers.com/claims/file-claim/business/cyber"
      },
      {
        "label": "Travelers claim services",
        "url": "https://www.travelers.com/claims/claim-services"
      }
    ],
    "kind": "insurer-panel",
    "needsCheck": true,
    "verifiedOn": "2026-11-03"
  },
  {
    "id": "insurer-coalition",
    "title": "Coalition: report a claim",
    "organization": "Coalition",
    "summary": "Page describes Coalition Incident Response as a premier on-call affiliate with digital forensics and incident expertise and says to refer to your contract for details. No outside panel or must-use rule is stated.",
    "urls": [
      {
        "label": "Coalition report a claim",
        "url": "https://www.coalitioninc.com/report-a-claim"
      }
    ],
    "kind": "insurer-panel",
    "needsCheck": true,
    "verifiedOn": "2026-11-03"
  },
  {
    "id": "insurer-atbay",
    "title": "At-Bay: claims",
    "organization": "At-Bay",
    "summary": "Page lists response partners (e.g. Arete, Kroll, At-Bay Response & Recovery) and says At-Bay Claims will reach out to determine which, if any, partners are needed. A footer link is titled 'Preferred Cyber Response Partners'. It does not say whether use is required.",
    "urls": [
      {
        "label": "At-Bay claims",
        "url": "https://www.at-bay.com/claims/"
      }
    ],
    "kind": "insurer-panel",
    "needsCheck": true,
    "verifiedOn": "2026-11-03"
  },
  {
    "id": "insurer-cna",
    "title": "CNA: Cyber vendors",
    "organization": "CNA",
    "summary": "Names forensic experts, breach counsel and other vendors it has identified, and says CNA's Claims team will work with the policyholder to choose the vendors that best fit their needs. Page does not say whether use is mandatory or how other vendors are pre-approved.",
    "urls": [
      {
        "label": "CNA cyber vendor support",
        "url": "https://www.cna.com/cyber-vendor-support"
      }
    ],
    "kind": "insurer-panel",
    "needsCheck": true,
    "verifiedOn": "2026-11-03"
  },
  {
    "id": "cred-gcfa",
    "title": "GIAC Certified Forensic Analyst (GCFA)",
    "organization": "GIAC",
    "summary": "Practitioner certification from GIAC (stated as ANAB-accredited to ISO/IEC 17024). Page describes coverage of advanced incident response and digital forensics, memory forensics, timeline analysis and threat hunting. Proctored hands-on CyberLive exam: 82 questions, 3 hours, 71% to pass.",
    "urls": [
      {
        "label": "GIAC GCFA",
        "url": "https://www.giac.org/certifications/certified-forensic-analyst-gcfa/"
      }
    ],
    "kind": "credential",
    "needsCheck": true,
    "verifiedOn": "2026-11-03"
  },
  {
    "id": "cred-gcih",
    "title": "GIAC Certified Incident Handler (GCIH)",
    "organization": "GIAC",
    "summary": "Practitioner certification covering incident handling and computer crime investigation, attacker techniques and tools. Proctored CyberLive exam: 106 questions, 4 hours, 69% to pass for versions released on or after May 10, 2025.",
    "urls": [
      {
        "label": "GIAC GCIH",
        "url": "https://www.giac.org/certifications/certified-incident-handler-gcih/"
      }
    ],
    "kind": "credential",
    "needsCheck": false,
    "verifiedOn": "2026-11-03"
  },
  {
    "id": "cred-gnfa",
    "title": "GIAC Network Forensic Analyst (GNFA)",
    "organization": "GIAC",
    "summary": "Practitioner certification covering network forensic artifacts, protocols, NetFlow analysis, logging and wireless analysis. Proctored CyberLive exam: 66 questions, 3 hours, 70% to pass.",
    "urls": [
      {
        "label": "GIAC GNFA",
        "url": "https://www.giac.org/certifications/network-forensic-analyst-gnfa/"
      }
    ],
    "kind": "credential",
    "needsCheck": false,
    "verifiedOn": "2026-11-03"
  },
  {
    "id": "cred-cissp",
    "title": "CISSP",
    "organization": "ISC2",
    "summary": "General information security certification from ISC2 covering 8 domains and requiring 5 years of work experience per the page. It is not specific to forensics or incident response.",
    "urls": [
      {
        "label": "ISC2 CISSP",
        "url": "https://www.isc2.org/certifications/cissp"
      }
    ],
    "kind": "credential",
    "needsCheck": true,
    "verifiedOn": "2026-11-03"
  },
  {
    "id": "cred-crest-individual",
    "title": "CREST individual incident response certifications",
    "organization": "CREST",
    "summary": "CREST's certifications page lists CREST Practitioner Intrusion Analyst (CPIA), Registered Intrusion Analyst (CRIA) and Certified Incident Manager (CCIM), with exams delivered at Pearson VUE. The page does not describe exam content or prerequisites.",
    "urls": [
      {
        "label": "CREST certifications",
        "url": "https://www.crest-approved.org/certification-careers/crest-certifications/"
      }
    ],
    "kind": "credential",
    "needsCheck": true,
    "verifiedOn": "2026-11-03"
  },
  {
    "id": "checklist-crest-supplier-guide",
    "title": "CREST Cyber Security Incident Response Supplier Selection Guide",
    "organization": "CREST",
    "summary": "A buyer's guide with questions grouped around a response framework (assignment, asset management, analysis, remediation, post-incident review). It frames four buying models: employ experts, buy a monitoring/response service, agree a response service in advance, or call someone when hit.",
    "urls": [
      {
        "label": "CREST CSIR Supplier Selection Guide v1 (PDF)",
        "url": "https://www.crest-approved.org/wp-content/uploads/2022/04/CSIR-Supplier-Selection-Guide.pdf"
      }
    ],
    "kind": "checklist",
    "needsCheck": true,
    "verifiedOn": "2026-11-03"
  }
]
export const IR_QUESTIONS: IrQuestion[] = [
  {
    "id": "q-retainer",
    "topic": "Retainer vs time-and-materials",
    "question": "Do you offer a retainer, and what are your terms if we have none (hourly rates, minimums, start time)?",
    "sourceLabel": "PCI SSC Responding to a Cardholder Data Breach: some PFIs offer services on retainer",
    "sourceUrl": "https://listings.pcisecuritystandards.org/documents/Responding_to_a_Cardholder_Data_Breach.pdf"
  },
  {
    "id": "q-start",
    "topic": "Availability",
    "question": "How quickly can a named lead start, and is first-level phone response 24x7?",
    "sourceLabel": "PCI SSC: PFIs provide 24x7x365 first-level response and start within five business days of signing (card breaches)",
    "sourceUrl": "https://listings.pcisecuritystandards.org/documents/Responding_to_a_Cardholder_Data_Breach.pdf"
  },
  {
    "id": "q-team",
    "topic": "Who is on the team",
    "question": "Who exactly will work on our case, who leads it, and what are their qualifications?",
    "sourceLabel": "CREST Supplier Selection Guide, Assignment: skills, competence and qualifications of the team",
    "sourceUrl": "https://www.crest-approved.org/wp-content/uploads/2022/04/CSIR-Supplier-Selection-Guide.pdf"
  },
  {
    "id": "q-independence",
    "topic": "Independence",
    "question": "Do you or any affiliate have another relationship with us or our vendors that could create a conflict of interest?",
    "sourceLabel": "PCI SSC: PFIs must be independent; your QSA firm cannot be your PFI",
    "sourceUrl": "https://listings.pcisecuritystandards.org/documents/Responding_to_a_Cardholder_Data_Breach.pdf"
  },
  {
    "id": "q-contract-roles",
    "topic": "Contract scope",
    "question": "What does the contract say about responsibilities, authority to act on our behalf, and limits on what you may do?",
    "sourceLabel": "NIST SP 800-61r3 Section 2.2: responsibilities, information flows and authority to act should be defined in a contract",
    "sourceUrl": "https://nvlpubs.nist.gov/nistpubs/SpecialPublications/NIST.SP.800-61r3.pdf"
  },
  {
    "id": "q-evidence",
    "topic": "Evidence handling",
    "question": "How do you collect, image, transfer, store and later return or destroy evidence, and do you keep chain-of-custody records?",
    "sourceLabel": "CREST Supplier Selection Guide, Asset Management: how assets/information are recorded, protected, returned or destroyed",
    "sourceUrl": "https://www.crest-approved.org/wp-content/uploads/2022/04/CSIR-Supplier-Selection-Guide.pdf"
  },
  {
    "id": "q-counsel",
    "topic": "Working through counsel",
    "question": "Will you work under the direction of our outside counsel, and how do you structure the engagement letter and reports?",
    "sourceLabel": "CISA IRP Basics: attorneys often have preferences on engaging outside incident response vendors",
    "sourceUrl": "https://www.cisa.gov/sites/default/files/publications/Incident-Response-Plan-Basics_508c.pdf"
  },
  {
    "id": "q-insurer",
    "topic": "Insurer approval",
    "question": "Are you approved by our cyber insurer, and will you work within its billing and reporting rules? Do we need pre-approval to use you?",
    "sourceLabel": "Chubb: policyholder is under no obligation to use panel providers and should do its own due diligence",
    "sourceUrl": "https://www.chubb.com/us-en/business-insurance/products/cyber-insurance/cyber-partners-for-mitigation-and-response.html"
  },
  {
    "id": "q-data",
    "topic": "Data handling",
    "question": "What access to our systems and data do you need, who at your firm will see it, where is it stored, and will you sign an NDA?",
    "sourceLabel": "NIST SP 800-61r3 Section 2.2: providers may have privileged access and sensitive data; NDAs and contracting clauses are options",
    "sourceUrl": "https://nvlpubs.nist.gov/nistpubs/SpecialPublications/NIST.SP.800-61r3.pdf"
  },
  {
    "id": "q-subs",
    "topic": "Subcontractors and information sharing",
    "question": "Do you use subcontractors or other customers' data/intelligence, and may you share anything about our incident with others?",
    "sourceLabel": "NIST SP 800-61r3 Section 2.2: restrictions on sharing sanitized incident information with other customers",
    "sourceUrl": "https://nvlpubs.nist.gov/nistpubs/SpecialPublications/NIST.SP.800-61r3.pdf"
  },
  {
    "id": "q-reporting",
    "topic": "Reporting",
    "question": "What will you report, to whom and how often, and what will the final report contain?",
    "sourceLabel": "FTC guide: work with forensics experts and act on their reports",
    "sourceUrl": "https://www.ftc.gov/business-guidance/resources/data-breach-response-guide-business"
  },
  {
    "id": "q-cred",
    "topic": "Credentials",
    "question": "Which certifications or accreditations do your investigators and your company hold, and how can I verify them?",
    "sourceLabel": "general practice",
    "sourceUrl": null
  },
  {
    "id": "q-pfi",
    "topic": "Card breaches",
    "question": "If payment cards are involved, are you on the current PCI SSC PFI list for the region where the breach occurred?",
    "sourceLabel": "PCI SSC PFI list: confirm status each time you engage a PFI",
    "sourceUrl": "https://www.pcisecuritystandards.org/assessors_and_solutions/pci_forensic_investigators"
  },
  {
    "id": "q-references",
    "topic": "References",
    "question": "Can you share references from similar-sized organizations and a sample (redacted) report?",
    "sourceLabel": "general practice",
    "sourceUrl": null
  },
  {
    "id": "q-fees",
    "topic": "Fees and scope change",
    "question": "What is excluded from your estimate (travel, tools, third-party licences, expert testimony) and how are changes approved?",
    "sourceLabel": "general practice",
    "sourceUrl": null
  }
]
